import React from 'react';
import { Link } from 'react-router-dom';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ServerDashboardJob } from '../../dashboardType';

const IDCell = (properties: CustomCellRendererProps<ServerDashboardJob>) => {
  const jobId = properties.value || properties.data?.jobId;

  if (!jobId) {
    return null;
  }

  const orchestrationLink = `/dashboard/orchestration/${jobId}`;

  return <Link to={orchestrationLink}>{jobId}</Link>;
};

export default IDCell;
